import { useSearchParams } from "react-router-dom";

export const SECTIONS = { gc: "General Council", mwjk: "MWJK" };

export function useSection() {
  const [p] = useSearchParams();
  const key = SECTIONS[p.get("s")] ? p.get("s") : "";
  return { key, name: SECTIONS[key] || "" };
}

export const inSection = (rec, name) => !name || !rec.destination || rec.destination === name;
